(ns basic-components.inputs.wysiwyg
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [cljs-uuid-utils.core :as uuid]
   [frontend.utils :as fu]
   [reagent.core :as r]
   [ui.components.rich-text.tiptap :as tiptap]))

(defn render
  [dom-atom args]
  (let [{:keys [value class-name on-focus! on-blur! on-change!]}
        args
        edit-value (or (:temp-value @dom-atom) value)
        clear-state! (fn []
                       (swap! dom-atom dissoc :temp-value))]
    [:div
     {:key        (str "wysiwyg-id-" (:guid @dom-atom) "-" (:version @dom-atom))
      :class-name (fu/cs "richtext__container" class-name)}
     [tiptap/editor
      {:value     edit-value
       :on-change (fn [value]
                    (swap! dom-atom assoc :temp-value value)
                    (when on-change!
                      (on-change! nil value)))
       :on-focus  (fn [e]
                    (when on-focus!
                      (on-focus! e)))
       :on-blur   (fn [e]
                    (when (fn? on-blur!)
                      (on-blur! e (:temp-value @dom-atom) clear-state!)))
       :show-alignment? true
       :show-block-type? false
       :inline-options [:bold :italic :underline]}]]))

(defmethod editor :editor.type/wysiwyg
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom {}))
        guid (->> (uuid/make-random-uuid)
                  (uuid/uuid-string))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                                                                ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Wysiwyg"
      :component-did-mount    (fn [_args]
                                ;; we use this to know where focus is changing - we can prevent blur if focus is changing to
                                ;; events withing this editor if needed
                                (swap! dom-atom assoc
                                       :guid guid
                                       :version 1)
                                (when set-focusable!
                                  (set-focusable! (fn [_]
                                                    (when-let [dom-node (:input-dom-node @dom-atom)]
                                                      (.focus dom-node)))))
                                (when set-cancel-edit!
                                  (set-cancel-edit! (fn [_]
                                                      (swap! dom-atom dissoc :temp-value)
                                                      (swap! dom-atom update :version inc))))     ;; save complete -> reset temp state
                                (when set-save!
                                  (set-save! (fn [_]
                                               (when-let [dom-node (:input-dom-node @dom-atom)]
                                                 (.blur dom-node))))))
      :component-will-unmount (fn [;; clear atom - dispose
                                   ])
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod editor :editor.type/richtext-mention
  [args]
  [editor (assoc args :editor/type :editor.type/wysiwyg)])

(defmethod display-string :editor.type/wysiwyg
  [args]
  (:value args))

(defmethod display-string :editor.type/richtext-mention
  [args]
  (display-string (assoc args :editor/type :editor.type/wysiwyg)))

(defmethod viewer :editor.type/wysiwyg
  [_args]
  (r/create-class
   {:display-name   "Wysiwyg/viewer"
    :reagent-render (fn [args]
                      [tiptap/viewer
                       {:class "preview preview-wysiwyg"
                        :value (fu/sanitize-html (:value args))}])}))

(defmethod viewer :editor.type/richtext-mention
  [args]
  [viewer (assoc args :editor/type :editor.type/wysiwyg)])
